import Base from './base'
import Request from '@utils/request'
import { toQueryString } from '@utils'

class Notification extends Base {
  async index (params = {}) {
    const url = `/api/notifications?${toQueryString(params)}`
    const response = await Request.get(url)

    return response
  }

  async read (id) {
    const url = `/api/notifications/${id}/read`
    const response = await Request.put(url)

    return response
  }
}

export default new Notification()
